@if (maintenanceNotice.banner(); as content) {
  <div class="maintenance-banner" role="status" aria-live="polite">
    <p class="maintenance-banner__text app-type-small">
      <span class="maintenance-banner__headline">{{ content.headline }}</span>
      @for (detail of content.details; track detail) {
        <span class="maintenance-banner__detail">{{ detail }}</span>
      }
    </p>
    @if (maintenanceNotice.dismissible()) {
      <button
        type="button"
        class="maintenance-banner__dismiss app-btn app-btn--ghost app-btn--compact"
        (click)="maintenanceNotice.dismiss()"
        aria-label="Dismiss maintenance notice"
      >
        Dismiss
      </button>
    }
  </div>
}
